import React from 'react';
import {alpha, Backdrop,CircularProgress,  Typography, Grid, Paper, CardHeader} from '@mui/material';
import { styled } from '@mui/material/styles';
import { IconButton, Card, CardActions, Collapse, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getRace } from '../services/api';
import {useState} from 'react';
import configData from '../services/config.json';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  marginTop: '3px',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  }));

export const RenderDashboardHeader = ({maintext, subtext}) => {
  return(
    <Grid container sx={{pb:0.2, mt:-6.6}} >
        <Grid item xs={12}>
            <Paper elevation={1} sx={{textAlign: 'center', width:'100%'}} >
              <Typography component="h1" variant="h6" sx={{ bgcolor: 'primary.main', color: 'info.contrastText', pt: 1.0, pl: 5, pr: 5, fontSize: {xs: '1rem', sm: '1.25rem'}}}> 
                {maintext}
              </Typography>
             
              <Typography variant="subtitle1" sx={{ bgcolor: 'primary.main', color: 'info.contrastText', p: 0 }}> 
                {subtext}
              </Typography>
            </Paper>
        </Grid>
    </Grid>
  );
}

export const WaitForData = ({show}) => {
  return (
          <Backdrop
            sx={{ color: '#bbb', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={show}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
  );
}

export const RenderRace = (race, showTime = false) => {
  const [expanded, setExpanded] = useState(false);
  const [result, setResult] = useState({race:race});
  const handleExpandClick = () => {
    if (!expanded) {
      getRace(race.id)
          .then (t=> {setResult(t);setExpanded(!expanded);}) 
    }
    else {
      setExpanded(!expanded);
    }
  };
      return (
              <Card sx={{m: 0.2, p:0.2, minWidth:350}} key={result.race.id}>
                  <CardHeader onClick={handleExpandClick} subheaderTypographyProps={{color:'info.contrastText'}} sx={{bgcolor: 'secondary.main', pr:5}} subheader={result.race.name}/>
                <CardActions sx={{mt:-8,mb:0.5}}>
                  <ExpandMore expand={expanded} onClick={handleExpandClick} aria-expanded={expanded} aria-label="show more" >
                  <ExpandMoreIcon sx={{color:'info.contrastText'}} />
                  </ExpandMore>
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                  {showTime ? (<ResultListTable rows={result.race.classifications} externallink= {result.race.mylapslink}/>) : <StartListTable rows={result.race.classifications}/>}
                </Collapse>
              </Card>
      );
}

export const GetRank = ({rank, validity}) => {
  switch (validity) {
    case 1:
      return 'DQ';
    case 2:
      return 'DNS';
    case 3:
      return 'DNF';
    default:
      return rank;
  }
}

export function ResultListTable({rows, externallink}) {
  //console.log(rows);

  const [hidePoints] = useState(Number.isNaN(rows.reduce((first, last) => first + last.totalPoints, 0)));
  const [hideTimes] = useState(Number.isNaN(rows.reduce((first, last) => first + last.chipTimeInSec, 0)));

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 280 }} aria-label="simple table" size="small">
        <TableHead>
          <TableRow sx={{backgroundColor: alpha('#f22',0.4) }}>
            <TableCell align="right" sx={{px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}>Plc</TableCell>
            <TableCell align="right" sx={{px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}>Bib</TableCell>
            <TableCell align="left" sx={{px: {xs: 1, md: 2} }}>Deltager</TableCell>
            {configData.SHOW_CATEGORY && (
              <>
              <TableCell align="left" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}>Kategori</TableCell>
              </>
            )}
            {!hideTimes && (
              <>
              <TableCell align="right" sx={{px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}>Tid</TableCell>
              <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}>Omg</TableCell>
              <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}>G.Km/t</TableCell>
              <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}><em>B.Km/t</em></TableCell>
              <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}><em>Omg</em></TableCell>
              <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}><em>Tid</em></TableCell>  
              </>
            )}
            {!hidePoints && (
              <TableCell align="right" sx={{px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}>Point</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.bib} sx={{backgroundColor: alpha('#f22',0.1)}} >
              <TableCell  align="right" component="th" scope="row" sx={{px: {xs: 1, md: 2} }} >
                <GetRank rank={row.rank} validity={row.validity} />
              </TableCell>

              <TableCell align="right" sx={{px: {xs: 1, md: 2} }}>
                {row.playerlink && (
                  <a href={row.playerlink} target="_blank" rel="noreferrer">{row.bib} </a>
                )}
                {!row.playerlink && (
                  row.bib
                )}
              </TableCell>
              <TableCell align="left" sx={{px: {xs: 1, md: 2} }}>{row.name}</TableCell>
              {configData.SHOW_CATEGORY && (
                <>
                <TableCell align="left" style={{width: '1px', whiteSpace: 'nowrap'}} sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2} }}>{<> {row.category} </>}</TableCell>
                </>
              )}
              {!hideTimes && (
                <>
                <TableCell align="right" sx={{px: {xs: 1, md: 2} }}><strong>{row.gunTimeInSec ? <> {row.gunTime} </> : <> - </>}</strong></TableCell>
                <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2} }}>{row.gunTimeInSec ? <> {row.totalLaps} </> : <></>}</TableCell>
                <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2} }}>{row.gunTimeInSec ? <> {row.displaySpeed} </> : <></>}</TableCell>
                <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2}, backgroundColor: alpha('#f22',0.1) }}><em>{row.gunTimeInSec && row.totalLaps > 1 ? <> {row.displayBestSpeed.substring(0,5)} </> : <></>}</em></TableCell>
                <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2}, backgroundColor: alpha('#f22',0.1) }}><em>{row.gunTimeInSec && row.totalLaps > 1 ? <> {row.bestLap} </> : <></>}</em></TableCell>
                <TableCell align="right" sx={{display: {xs: "none", sm: "table-cell"}, px: {xs: 1, md: 2}, backgroundColor: alpha('#f22',0.1) }}><em>{row.gunTimeInSec && row.totalLaps > 1 ? <> {row.bestTime} </> : <></>}</em></TableCell>
                </>
              )}              
              {!hidePoints && (
                <TableCell align="right" sx={{px: {xs: 1, md: 2} }}><strong>{row.totalPoints}</strong></TableCell>
              )}
            </TableRow>
          ))}
          
        </TableBody>
                
      </Table>
      {externallink && (
        <Table sx={{ minWidth: 280 }} aria-label="simple table" size="small">
          <TableHead>
            <TableRow sx={{backgroundColor: alpha('#f22',0.4) }}>
              <TableCell align="right" sx={{px: {xs: 1, md: 2} }} style={{width: '1px', whiteSpace: 'nowrap'}}> <a href={externallink} target="_blank" rel="noreferrer"> Se mere på mylaps...</a> </TableCell>
            </TableRow>
          </TableHead>
        </Table>
      )}
    </TableContainer>
  );
}


export function StartListTable({rows}) {
//  console.log(rows);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 300 }} aria-label="simple table" size="small">
        <TableHead>
          <TableRow sx={{backgroundColor: alpha('#f22',0.4) }}>
            <TableCell align="right" style={{width: '1px', whiteSpace: 'nowrap'}}>Pos</TableCell>
            <TableCell align="right" style={{width: '1px', whiteSpace: 'nowrap'}}>Bib</TableCell>
            <TableCell align="left">Deltager</TableCell>
            {configData.SHOW_CATEGORY && (
              <>
              <TableCell align="left" style={{width: '1px', whiteSpace: 'nowrap'}}>Kategori</TableCell>
              </>
            )}

          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.bib} sx={{backgroundColor: alpha('#f22',0.1)}} >
              <TableCell align="right">{row.rank}</TableCell>
              <TableCell align="right">{row.bib}</TableCell>
              <TableCell align="left">{row.name}</TableCell>
              {configData.SHOW_CATEGORY && (
                <>
                <TableCell align="left" style={{width: '1px', whiteSpace: 'nowrap'}}>{<> {row.category} </>}</TableCell>
                </>
              )}              
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
